import React from 'react';
import { Form } from 'antd';
import { SearchableInput } from '../../common';
import { Persona } from '../../../hooks/usePersonas';
import { theme } from '../../../theme';

interface PersonaSearchFieldProps {
  label: string;
  required?: boolean;
  personas: Persona[];
  selectedPersona: Persona | null;
  onSelect: (persona: Persona | null) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const PersonaSearchField: React.FC<PersonaSearchFieldProps> = ({
  label,
  required = false,
  personas,
  selectedPersona,
  onSelect,
  disabled = false,
  placeholder = 'Buscar por NC o denominación...'
}) => {
  return (
    <Form.Item
      label={
        <span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>
          {label} {required && <span style={{ color: theme.colors.error }}>*</span>}
        </span>
      }
      required={required}
      style={{ marginBottom: 0 }}
    >
      <SearchableInput<Persona>
        items={personas}
        value={selectedPersona}
        onSelect={onSelect}
        placeholder={placeholder}
        size="small"
        disabled={disabled}
        searchFields={['nc', 'denominacion']}
      />
    </Form.Item>
  );
};

